module.exports = __webpack_public_path__ + "components/outside-promo-page/static/companies-mobile-2bf17fe6a7761ecc675060784ef00b47.svg";